
// action - state management

import {
    GET_CMS,GET_CMS_List
} from "./actions";

// ==============================|| ACCOUNT REDUCER ||============================== //

const initialState = {
    cmsData:{},
    cmsList:{
        docs: [],
        totalDocs: 0,
        limit: 10,
        page: 1,
        totalPages: 0,
        pagingCounter: 0,
        hasPrevPage: false,
        hasNextPage: false,
        prevPage: null,
        nextPage: null,
    },
   
loading:true

};


export const cmsReducer =  (state = initialState, action) => {  
  
  const { type, payload } = action;
  switch (type) {
    case GET_CMS:
      return {
        ...state,
        cmsData: payload,
        loading: false,
      };
case GET_CMS_List:
    return {
        ...state,
        cmsList:payload
    }
    
    default:
      return state;
  }
}

export default cmsReducer;